import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { decryptData, encryptData } from '@helper/encryptDecrypt';
import { authCookiesOption } from '../constant';

export const useIsImpersonationLoginUser = (): boolean => {
	const [isImpersonationLoginUser, setIsImpersonationLoginUser] = useState(false);

	useEffect(() => {
		const cookies = new Cookies();

		const encryptedValue =
			localStorage.getItem('isImporsonationLoginUser') ??
			sessionStorage.getItem('isImporsonationLoginUser') ??
			cookies.get('isImporsonationLoginUser');

		if (!encryptedValue) {
			setIsImpersonationLoginUser(false);
			return;
		}

		const checkImpersonationUser = async (): Promise<void> => {
			try {
				const decryptedValue = await decryptData(encryptedValue);
				const cookie = new Cookies();
				const encryptRole = await encryptData('true');
				cookie.set('isImporsonationLoginUser', encryptRole, { ...authCookiesOption() });
				setIsImpersonationLoginUser(decryptedValue === 'true');
			} catch (error) {
				console.error('Error decrypting impersonation login flag:', error);

				setIsImpersonationLoginUser(false);
			}
		};

		void checkImpersonationUser();
	}, []);

	return isImpersonationLoginUser;
};
